import './SocialMedia.scss';